/** Compte plateforme CRM. */
export function isCrmPlatformAdmin(user) {
  return user?.permission === 'admin';
}

/** Gestion CRM : campagnes, produits campagne, templates email associés. */
export function canManageCrmCampaigns(user) {
  if (!user) return false;
  if (isCrmPlatformAdmin(user)) return true;
  if (user.crmManager === true) return true;
  return user.permission === 'team' && user.crm === true;
}
